import React from 'react';
import ReactDOM from 'react-dom/client';
// import {BrowserRouter as HashRouter} from 'react-router-dom';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        {/*<Provider store={store}>*/}
            {/*<Router>*/}
            {/* <HashRouter> */}
                <App/>
            {/* </HashRouter> */}
            {/*</Router>*/}
        {/*</Provider>*/}

    </React.StrictMode>
);
